'use client';
import { jsx } from 'react/jsx-runtime';
import { useFloatingLabelFormElement } from '../../contexts/internal/floating-label/index.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { useFormFieldProps } from '../form/form.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const Dropdown = renderWithRef('Dropdown', null, (t, s)=>{
    let { children: c, skin: a = 'standard', size: d = 'standard', fullWidth: l = false, id: u, htmlSize: b } = t, f = _object_without_properties(t, [
        "children",
        "skin",
        "size",
        "fullWidth",
        "id",
        "htmlSize"
    ]);
    useDeprecatedProps('Dropdown', t, [
        {
            propName: 'skin',
            deprecatedValues: {
                line: 'Use skin="standard" instead'
            }
        },
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        }
    ]);
    let w = useId(u), m = useFloatingLabelFormElement(_object_spread_props(_object_spread({}, f), {
        id: w
    })), _ = useFormFieldProps(m.id), y = new Set([
        'swan-dropdown'
    ]);
    return 'mini' === d && y.add("swan-dropdown-mini"), ('error' === a || _['aria-invalid']) && y.add("swan-dropdown-skin-error"), 'line' === a && y.add("swan-dropdown-skin-line"), l && y.add("swan-dropdown-full-width"), jsx(RenderComp, {
        root: "select",
        classNames: y,
        forwardedRef: s,
        props: _object_spread_props(_object_spread({}, m, _), {
            size: b
        }),
        children: c
    });
});

export { Dropdown };
